import React from 'react';

const NotificationsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-6">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-md overflow-hidden border">
          <div className="bg-gradient-to-b from-[#C10930] to-[#6D081D] text-white font-extrabold px-4 py-3 text-lg">
            Notification
          </div>

          <div className="bg-white px-4 py-8">
            <div className="text-center">
              {/* Bell Icon */}
              <div className="mb-6">
                <svg 
                  width="80" 
                  height="80" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="#4CAF50" 
                  strokeWidth="2" 
                  className="mx-auto"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  <circle cx="12" cy="12" r="1" fill="#4CAF50" />
                  <circle cx="8" cy="8" r="1" fill="#4CAF50" />
                  <path d="M4 4l2 2m12-2l-2 2" strokeWidth="1" />
                  <path d="M8 16l2-2m4 2l-2-2" strokeWidth="1" />
                </svg>
              </div>

              {/* Main Message */}
              <h2 className="text-xl font-bold text-gray-900 mb-3">
                No notification yet!
              </h2>

              {/* Descriptive Text */}
              <p className="text-gray-600 text-sm leading-relaxed">
                Check this section for updated, news<br />
                and general notification
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
